import { FCupParticipants } from '@/types/friendCup';
import { formatNumberToLocale } from '@/utils/functions';

export const ItemRanking = ({
  participant,
}: {
  participant: FCupParticipants;
}) => {
  return (
    <div className="flex justify-stretch bg-white border-b-gdt-gray-6 border-b-[1px] px-4 lg:px-7 lg:py-6 text-xs font-semibold text-gdt-gray-3 py-4">
      <div className="flex-1">
        <p className="font-bold lg:text-sm text-2xs text-gdt-gray">
          {participant.nombreYApellido}
        </p>
        <span className="font-semibold lg:text-sm text-2xs">
          {participant.nombreEquipo}
        </span>
      </div>
      <div className="flex justify-around items-center">
        <p className="lg:w-[188px] w-[60px] text-center font-semibold lg:text-base text-xs  text-gdt-gray-2">
          {(participant.puntos && Array.isArray(participant.puntos)) ||
          participant.puntos === 0
            ? '-'
            : participant.puntos}
        </p>
        <p className="lg:w-[188px] w-[88px]  text-center font-semibold lg:text-base text-xs  text-gdt-gray">
          {participant.puntosAcumulados !== 0
            ? formatNumberToLocale(participant.puntosAcumulados)
            : '-'}
        </p>
      </div>
    </div>
  );
};
